module.exports = __webpack_public_path__ + "static/media/que-hacer-en-palermo.8764be4c.md";